import './Dropdown.scss';
import { forwardRef } from "react";
import { Dropdown as PrDropdown } from 'primereact/dropdown'
import classNames from "classnames";

const Dropdown = forwardRef(({ className, panelClassName, onChange,handleChange=()=>{}, ...props }, ref) => {
  return (
    <PrDropdown
      onChange={(e) => { handleChange(e);onChange(e) }}
      ref={ref} className={classNames('Dropdown', className)} panelClassName={classNames('DropDownPanel', panelClassName)} {...props} />
  )
})

export default Dropdown